import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const allFlags = [
  'colombia', 'argentina', 'brasil', 'espana', 'francia', 'alemania', 'japon', 
  'inglaterra', 'portugal', 'holanda', 'uruguay', 'belgica', 'suiza', 'australia',
  'italia', 'corea', 'ecuador', 'sudafrica', 'noruega', 'paraguay', 'croacia'
];

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-black text-white font-sans">
      
      {/* HERO SECTION - Aumentamos pt-32 a pt-48 para dar espacio al logo grande */}
      <section
        className="relative flex flex-col items-center justify-center flex-grow text-center px-6 pt-48 pb-20 bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/stadium.png')" }}
      >
        {/* Overlay degradado */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/20 to-black" />

        {/* CARRUSEL DE BANDERAS - Cambiado top-24 a top-32 (o top-40) para que baje */}
        <div className="absolute top-32 md:top-40 left-0 w-full overflow-hidden bg-black/40 backdrop-blur-sm border-y border-white/10 py-2">
          <motion.div 
            className="flex gap-8 whitespace-nowrap"
            animate={{ x: [0, -1000] }}
            transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
          >
            {[...allFlags, ...allFlags].map((code, i) => (
              <img key={i} src={`/flags/${code}.png`} alt={code} className="h-6 opacity-80" />
            ))}
          </motion.div>
        </div>

        {/* HERO CONTENT */}
        <div className="relative z-10 max-w-4xl">
          <motion.h1
            className="text-6xl md:text-8xl font-black mb-6 uppercase tracking-tighter"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
          >
            <span className="bg-gradient-to-r from-yellow-400 via-orange-500 to-yellow-600 bg-clip-text text-transparent drop-shadow-2xl">
              Mundial 2026
            </span>
          </motion.h1>

          <motion.p
            className="text-xl md:text-2xl font-light tracking-wide text-gray-200 mb-12 italic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            "Donde la pasión se convierte en predicción"
          </motion.p>

          {/* HOST COUNTRIES */}
          <div className="flex flex-col items-center gap-6">
            <span className="text-xs uppercase tracking-[0.3em] text-yellow-500 font-bold">Sedes Oficiales</span>
            <div className="flex justify-center gap-12 bg-white/5 p-8 rounded-3xl backdrop-blur-md border border-white/10">
              {['usa', 'mexico', 'canada'].map((code, i) => (
                <motion.div key={code} className="flex flex-col items-center gap-3">
                  <motion.img
                    src={`/flags/${code}.png`}
                    className="w-16 md:w-24 drop-shadow-[0_0_15px_rgba(255,255,255,0.3)]"
                    whileHover={{ scale: 1.1, rotate: 5 }}
                  />
                  <span className="text-[10px] uppercase font-bold opacity-60">{code}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-black py-8 border-t border-white/5 text-center text-gray-500 text-sm tracking-widest">
        © 2026 GOLÍSTICO · EL JUEGO DE LAS NACIONES
      </footer>
    </div>
  );
}